var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgAttention = function SvgAttention(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#Attention_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14 0c7.732 0 14 6.268 14 14s-6.268 14-14 14S0 21.732 0 14 6.268 0 14 0Z",
    fill: "#F2F4FB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.938 7a.58.58 0 0 1 .455.221l.043.063 2.48 4.137a.598.598 0 0 1-.01.627l-.044.06-6.417 7.683a.578.578 0 0 1-.841.052l-.05-.052-6.416-7.682a.597.597 0 0 1-.088-.622l.035-.066 2.479-4.137a.583.583 0 0 1 .423-.279L10.062 7h7.876Zm-1.888 5.318H11.95l2.05 5.125 2.051-5.125Zm3.109 0h-1.85l-1.701 4.252 3.551-4.252Zm-8.469 0H8.84l3.551 4.25-1.7-4.25Zm.787-4.136H10.39l-1.771 2.954h2.024l.833-2.954Zm3.833 0h-2.62l-.834 2.954h4.288l-.834-2.954Zm2.3 0h-1.087l.834 2.954h2.024L17.61 8.182Z",
    fill: "#5C7AFF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "Attention_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h28v28H0z"
  })))));
};

export default SvgAttention;